<script>
  import { OverflowMenu, OverflowMenuItem } from "carbon-components-svelte";
  import { uiFeatureStore } from "@stores/uiFeatureStore.js";

  export let selected = 0;
  export let featureControlled = true;
  export let options = [
    {
      text: "Registrations",
      icon: "account_tree",
    },
    {
      text: "Main",
      icon: "global",
    },
  ];

  $: if (
    featureControlled &&
    !$uiFeatureStore.platformFeatures.registrationsGlobalSwitch
  ) {
    selected = 0;
  }

  function toggleDataSource() {
    if (options.length > 1) selected = selected === 0 ? 1 : 0;
  }
</script>

{#if !featureControlled ||
  $uiFeatureStore.platformFeatures.registrationsGlobalSwitch}
  <div class="source_menu">
    <OverflowMenu style="width: auto; height: 2.6rem;">
      <div slot="menu">
        <div class="source_menu_trigger" role="button" tabindex="0" title="Switch data source" on:click|stopPropagation={toggleDataSource} on:keydown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); toggleDataSource(); } }}>
          <div class="source_menu_text">
            <span class="source_menu_type">Data</span>
            <span class="source_menu_value">{options[selected]?.text || options[0].text}</span>
          </div>
          <span class="source_menu_swap" aria-hidden="true">
            <img src="/img/assistant/icons/swap.svg" alt="" />
          </span>
        </div>
      </div>
      {#each options as option, index}
        <OverflowMenuItem
          text={option.text}
          disabled={option.disabled}
          on:click={() => (selected = index)}
          primaryFocus={selected === index}
        >
          <div class="source_menu_option">
            <img
              src="/img/assistant/icons/{option.icon}.svg"
              alt=""
            />
            <span>{option.text}</span>
          </div>
        </OverflowMenuItem>
      {/each}
    </OverflowMenu>
  </div>
{/if}

<style>
  .source_menu { display: flex; width: fit-content; height: var(--app-header-height); margin-right: -0.5rem; align-items: center; border-left: 1px solid var(--border-color); }

  .source_menu :global(.bx--overflow-menu),
  .source_menu :global(.bx--overflow-menu__trigger) {
    width: auto;
    height: var(--app-header-height) !important;
    min-height: var(--app-header-height);
    padding: 0;
    border: none;
    border-radius: 0;
    background: var(--pax-white) !important;
    box-sizing: border-box;
  }

  .source_menu :global(.bx--overflow-menu:hover) {
    background: var(--pax-white) !important;
  }

  .source_menu :global(.bx--overflow-menu__trigger:focus),
  .source_menu :global(.bx--overflow-menu__trigger:active),
  .source_menu :global(.bx--overflow-menu__trigger[aria-expanded="true"]) {
    background: var(--pax-white) !important;
    box-shadow: none;
  }

  .source_menu :global(.bx--overflow-menu-options) {
    margin-top: 0.25rem;
  }

  .source_menu_trigger {
    display: flex;
    width: fit-content;
    /* 1px shorter than the header, otherwise the white background covers its
       bottom border - same as .header_filter_button in Filter.svelte */
    height: calc(var(--app-header-height) - 1px) !important;
    min-height: calc(var(--app-header-height) - 1px);
    min-width: 0;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    padding: 0 0.6rem;
    box-sizing: border-box;
    color: var(--pax-black);
    background: var(--pax-white);
    white-space: nowrap;
  }

  .source_menu_trigger:hover {
    background-color: var(--pax-white);
  }

  .source_menu_type {
    color: #555b63;
    font-size: 0.9rem;
    line-height: 1.2;
  }

  .source_menu_value {
    font-size: 0.9rem;
    font-weight: 700;
    line-height: 1.2;
  }

  .source_menu_text { display: flex; min-width: 0; flex-direction: column; align-items: flex-start; }
  .source_menu_swap { display: grid; width: 1.3rem; height: 1.3rem; flex: 0 0 auto; place-items: center; border-radius: 50%; background: #e7e8ea; }
  .source_menu_swap img { width: 1rem; height: 1rem; filter: brightness(0); }

  .source_menu_option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .source_menu_option img {
    width: 1rem;
    height: 1rem;
    filter: brightness(0);
  }
</style>
